import React from "react";
import BaseModal from "@components/common/HPBaseModal";
import { WarningIcon } from "@assets/images";
import { ModalProps } from "@_constants/modal";
import { t } from "@utils/i18n";

interface NoDatasetsAvailableModalProps extends ModalProps {
  action: () => void;
}

const NoDatasetsAvailableModal: React.FC<NoDatasetsAvailableModalProps> = ({
  action,
  closeAction,
}) => {
  return (
    <BaseModal
      title={t("modals.noDatasets.title")}
      onCancel={closeAction}
      onConfirm={action}
      cancelButtonText={t("common.cancel")}
      confirmButtonText={t("modals.noDatasets.confirmButton")}
      headerIcon={<WarningIcon />}
      message={t("modals.noDatasets.message")}
    />
  );
};

export default NoDatasetsAvailableModal;
